<div class="row" *ngIf="editForm">
  <div class="ir-area ir-mask th-mask">
    <form class="ir-modal th-modal" [formGroup]="editForm">
      <div class="ir-modal--title">
        <div class="ir-line--right"></div>
        <div class="ir-line">
          <div class="ir-line-content">
            <span>{{ 'inspections.reports.share-report' | translate: inspection }} </span>
          </div>
        </div>
      </div>
      <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
        <div class="ir-content--modal th-content">
          <table class="ir-modal-table">
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.To' | translate }}</span>
                </h2>
              </td>
              <td colspan="2" class="margin-big">
                <div class="ir-form-group">
                  <input type="text" (keypress)="pressEnter($event)" name="to" class="ir-form-set" formControlName="to" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.From' | translate }}</span>
                </h2>
              </td>
              <td colspan="2" class="margin-big">
                <div class="ir-form-group">
                  <span>{{ from }}</span>
                </div>
              </td>
            </tr>

            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.message' | translate }}</span>
                </h2>
              </td>
              <td colspan="2" class="margin-big">
                <div class="ir-form-group">
                  <textarea
                    autosize
                    name="message"
                    formControlName="message"
                    [minRows]="5"
                    [maxRows]="20"
                    class="ir-form-set"
                  ></textarea>
                </div>
              </td>
            </tr>
            <tr *ngIf="isMaitenance">
              <td class="margin-big">
                <span></span>
              </td>
              <td class="margin-big">
                <div class="ir-item-line clickable indent nobreak" (click)="updateFullReport()">
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!fullReport">check_box_outline_blank</i>
                      <i class="material-icons" *ngIf="fullReport">check_box</i>
                    </div>
                    <span>{{ 'inspections.reports.full-report' | translate }}</span>
                  </div>
                </div>
              </td>
                <td class="margin-big">
                <div class="ir-item-line clickable indent nobreak" (click)="updateFullReportWithoutPrice()">
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!fullReportWithoutPrices">check_box_outline_blank</i>
                      <i class="material-icons" *ngIf="fullReportWithoutPrices">check_box</i>
                    </div>
                    <span>{{ 'inspections.reports.full-report-without-prices' | translate }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <span></span>
              </td>
              <td colspan="2" class="margin-big">
                <div class="ir-item-line clickable indent nobreak" (click)="updateCopy()">
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!copy">check_box_outline_blank</i>
                      <i class="material-icons" *ngIf="copy">check_box</i>
                    </div>
                    <span>{{ 'common.receive-message-copy' | translate }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-modal--footer ir-position--b th-modal--footer">
        <div class="ir-row">
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
              <span>{{ 'common.cancel' | translate }}</span>
            </div>
          </div>
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
              (click)="share(editForm.value)"
              [disabled]="editForm.invalid"
              *ngIf="!processing"
            >
              <span>{{ 'common.share' | translate }}</span>
            </button>
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
              type="submit"
              *ngIf="processing"
            >
              <span>{{ 'common.processing' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<information
  #sentInformation
  (confirmOutput)="closeSentInformation()"
  [title]="'common.sent-information' | translate"
  [message]="'report.sent-information-message' | translate"
></information>
